// import { hubReducer, HubState } from './sockets/reducer';
import { Reducer, combineReducers } from 'redux';
import { applicationReducer } from './application/reducers';
import {dealerServiceReducer, DealerServiceState} from "./dealerService/reducer";
import {INotificationsState, notificationReducer} from "./Notifications/reducer";
import {adminReducer, IAdminState} from "./Admin/reducer";
import { IPreferenceState, preferencesReducer } from './preferences/reducer';
import { ApplicationState } from './application/types';

export interface AppState {
  applications: ApplicationState;
  // messageHub: HubState,
  dealerService: DealerServiceState;
  notifications: INotificationsState;
  admin: IAdminState;
  preferences: IPreferenceState;
}
export const rootReducer: Reducer<AppState> = combineReducers<AppState>({
    applications: applicationReducer,
    // messageHub: hubReducer,
    dealerService: dealerServiceReducer,
    notifications: notificationReducer,
    preferences: preferencesReducer,
    admin: adminReducer
});